<!-- header start -->
<app-header-one [transparent]="true" [white_bg]="true"></app-header-one>
<!-- header end -->

<main>

  <!-- breadcrumb start -->
  <app-breadcrumb-one title="Shop" subtitle="Shop"></app-breadcrumb-one>
  <!-- breadcrumb end -->

  <!-- shop area start -->
  <app-shop-area></app-shop-area>
  <!-- shop area end -->
</main>

<!-- footer start -->
<app-footer-one></app-footer-one>
<!-- footer end -->
